import React, { useEffect } from 'react'
import { batch, useSignal } from '@preact/signals-react'
import { TextFieldSeeker } from '@ui-seeker/core'
import { useAppFormHandler } from '@hooks'
import { formData, formErrors } from '@signals'
import { object, string } from 'yup'
import { useValidatorSeeker } from '@ui-seeker/app'


export default function NewAcrissSelector() {

	const newAcriss = useSignal('')
	const { acrissOptions, onAcrissOptionsChange } = useAppFormHandler('acrissOptions')

	const { errors, isValid } = useValidatorSeeker({ newAcriss: newAcriss.value }, object(!!newAcriss.value && {
		newAcriss: string().matches(/^[A-Z]{4}$/, 'Acriss code must be 4 uppercase letters only'),
	}))

	useEffect(() => {
		formErrors.value = { ...formErrors.value, acrissOptions: isValid }
	}, [isValid])

	return <TextFieldSeeker
		error={errors.newAcriss}
		placeholder="Add new Acriss"
		label="Add new Acriss"
		onChange={e => batch(() => {
			const targetValue = e.target.value.toUpperCase()
			const existingOption = acrissOptions.find(({ label }) => label === e.target.value)
			newAcriss.value = targetValue

			if (!targetValue) {
				onAcrissOptionsChange(acrissOptions.slice(0, -1))
			} else if (existingOption) {
				formData.value = { ...formData.value, acriss: existingOption?.value }
			} else {
				onAcrissOptionsChange([...acrissOptions.slice(0, -1), { label: targetValue, value: targetValue }])
			}
			formData.value = { ...formData.value, acriss: targetValue }
		})}
		value={newAcriss.value}
	/>
}